<template>
  <div
    id="login"
    class="bg-white flex items-center justify-center h-screen w-screen back"
  >
    <section class="box login">
      <div class="content px-8 py-12 rounded-b border border-1 border-solid">
        <label
          for
          class="block w-full text-gray-800 text-2xl label"
          style="font-size: 150%"
          >Username*</label
        >
        <input
          spellcheck="false"
          name="userName"
          v-model="userName"
          v-focus
          style="font-size: 150%"
          class="text-4xl text-transform-none w-full h-12 mt-2 mb-1 bg-gray-light rounded p-3 focus:outline-none focus:bg-white focus:text-blue-800 text-gray-darkest focus:border-blue-800 border-transparent border-2 border-black"
        />
        <label
          for
          class="block w-full text-gray-800 text-2xl label"
          style="font-size: 150%"
          >Password*</label
        >
        <div
          class="flex flex-row text-transform-none h-12 mt-2 mb-1 bg-white rounded"
        >
          <input
            name="password"
            type="password"
            v-model="password"
            style="font-size: 150%"
            class="text-4xl text-transform-none w-full bg-gray-light rounded p-3 focus:outline-none focus:bg-white focus:text-blue-800 text-gray-darkest focus:border-blue-800 border-transparent border-2 border-black"
          />
        </div>
        <button
          @click="goToMainPage()"
          class="w-full h-12 mt-2 rounded-sm bg-button label text-whiteText text-xs"
        >
          SIGN IN
        </button>
      </div>
    </section>
  </div>
</template>

<script>
import Http, { OCR_ENDPOINTS } from "../request";
import store from "../store/";
import AdminPermissions from "../data/adminPermissions";
import UserPermissions from "../data/userPermissions";
import SuperAdminPermissions from "../data/superAdminPermissions";
import ClientPermissions from "../data/clientPermissions";
export default {
  data() {
    return {
      userName: "",
      password: "",
    };
  },

  created() {},

  methods: {
    goToMainPage() {
      Http()
        .post(OCR_ENDPOINTS.login, {
          username: this.userName,
          password: this.password,
        })
        .then((response) => {
          if (response.data) {
            store.commit("login", response.data);
            store.commit("username", this.userName);
            if (response.data.userType.id == 1) {
              store.commit("permissions", AdminPermissions);
            } else if (response.data.userType.id == 2) {
              console.log(UserPermissions);
              store.commit("permissions", UserPermissions);
            } else if (response.data.userType.id == 3) {
              console.log(ClientPermissions);
              store.commit("permissions", ClientPermissions);
            } else if (response.data.userType.id == 4) {
              console.log(SuperAdminPermissions);
              store.commit("permissions", SuperAdminPermissions);
            }
            this.$emit("loggedIn");
          }
        })
        .catch((error) => {
          this.$toast.error(error.response.data);
        });
    },
  },
};
</script>
<style scoped>
.login:hover {
  box-shadow: 1px 1px #000000, 2px 2px #000000, 3px 3px #04080a;
}

.login {
  transition: 0.5s;
  background: #fff;
}
</style>
